import { render, staticRenderFns } from "./EntityManager.vue?vue&type=template&id=e04bedd8&"
import script from "./EntityManager.vue?vue&type=script&lang=ts&"
export * from "./EntityManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports